import './Range.scss'

import React from 'react'
import { Range as VendorRange, getTrackBackground } from 'react-range'

/**
 * Range slider form element.
 * @param {Object} props
 * @param {string} [props.className] Additional classes
 * @param {number} [props.step=1] Amount of one step
 * @param {number} [props.min=0] Minimum value
 * @param {number} props.max Maximum value
 * @param {[number, number]} props.value Current values
 * @param {string} props.name Name of the form element
 * @param {(value: [number, number], name: string) => void} props.onChange
 * @param {string} [props.id] DOM element ID
 */
const Range = props => {
    const { className, step, onChange, name, min, max, value, id } = props

    const renderTrack = ({ props, children }) => (
        <div {...props} className="range-track">
            {children}
            <div className="range-overlay" style={{
                backgroundImage: getTrackBackground({
                    min: min || 0,
                    max,
                    values: value,
                    colors: ['var(--background)', 'transparent', 'var(--background)'],
                }),
            }} />
        </div>
    )

    const renderThumb = ({ props }) => (
        <div {...props} className="range-thumb" />
    )

    const vendorRangeProps = {
        renderTrack,
        renderThumb,
        step: step || 1,
        min: min || 0,
        max,
        values: value,
        onChange: values => onChange(values, name),
    }

    return (
        <div id={id} className={'range' + (className ? ' ' + className : '')}>
            <VendorRange {...vendorRangeProps} />
        </div>
    )
}

export default Range
